"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../Constants");
const coord_helper_service_1 = require("../../service/coord-helper.service");
const plugins_1 = require("./plugins");
const Cesium = window.Cesium;
class SelectionAreaHandler extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.debug = Constants_1.Constants.debug_off;
        this.mouseHandler = null;
        this.mouseCoords = null;
        this.mouseCartesian = null;
        this.dragging = null;
        // incoming coordinates
        this.coords = null;
        // geodesic box of the selector rectangle
        this.geodesics = { west: 0, south: 0, east: 0, north: 0 };
        this.cartesians = { west: 0, south: 0, east: 0, north: 0 };
        this.selectedCenter = null;
        this.rotation = 0;
        this.sizeX = 0;
        this.sizeY = 0;
        this.mapService = null;
        this.coordHelper = null;
    }
    init() {
        this.mapService = this.services.mapService;
        this.coordHelper = this.services.coordHelper;
        this.mouseHandler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.scene.canvas);
        // set up a mouse move handler
        this.mouseHandler.setInputAction((movement) => {
            this.onMouseClickEnd(movement);
        }, Cesium.ScreenSpaceEventType.LEFT_UP);
        this.mouseHandler.setInputAction((movement) => {
            this.onMouseClickStart(movement);
        }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
        // set up a mouse move handler
        this.mouseHandler.setInputAction((movement) => {
            this.onMouseMove(movement);
        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        this.finalisers.push(() => { if (this.mouseHandler) {
            this.mouseHandler.destroy();
        } });
        this.addEntityType('draggable-move', {
            show: this.show,
            billboard: {
                image: 'assets/images/icons/action-move.png',
                disableDepthTestDistance: 1500,
                scaleByDistance: new Cesium.NearFarScalar(0, 1.5, 1500, 0.4)
            },
        });
        this.addEntityType('draggable-size', {
            show: this.show,
            billboard: {
                image: 'assets/images/icons/action-size.png',
                disableDepthTestDistance: 1500,
                scaleByDistance: new Cesium.NearFarScalar(0, 1.5, 1500, 0.4)
            },
        });
    }
    // not sure how this one works yet (@alex)
    setCameraController(state) {
        this.mapService.viewer.scene.screenSpaceCameraController.enableRotate = state;
        this.mapService.viewer.scene.screenSpaceCameraController.enableZoom = state;
        this.mapService.viewer.scene.screenSpaceCameraController.enableLook = state;
        this.mapService.viewer.scene.screenSpaceCameraController.enableTilt = state;
        this.mapService.viewer.scene.screenSpaceCameraController.enableTranslate = state;
    }
    onMouseClickStart(movement = null) {
        this.mouseCoords = movement.position;
        this.mouseCartesian = this.mapService.viewer.scene.pickPosition(this.mouseCoords);
        // console.log ( 'click START', movement, this.mouseCoords, this.mouseCartesian );
        let pickedObjects = this.pickObjects();
        if (pickedObjects) {
            // loop through all found objects, looking for 3DTilesets
            pickedObjects.forEach(pickedObject => {
                if (pickedObject && pickedObject.id && pickedObject.id.__type) {
                    // console.log ( 'click START found', pickedObject );
                    if (pickedObject.id.__type == 'draggable-move' || pickedObject.id.__type == 'draggable-size') {
                        this.dragging = pickedObject.id;
                        this.setCameraController(false);
                        console.log('click START found AREA_DRAGGER', pickedObject.id);
                    }
                }
            });
        }
    }
    onMouseClickEnd(movement = null) {
        console.log('click END', movement);
        this.dragging = false;
        this.setCameraController(true);
    }
    onMouseMove(movement = null) {
        this.mouseCoords = movement.endPosition;
        if (this.dragging) {
            this.mouseCartesian = this.mapService.viewer.scene.pickPosition(this.mouseCoords);
            var positionCartographic = Cesium.Ellipsoid.WGS84.cartesianToCartographic(this.mouseCartesian);
            if (this.mouseCartesian) {
                this.dragging.position = this.mouseCartesian;
                if (this.dragging.__type == 'draggable-size') {
                    let c = this.dragging.position._value;
                    let x = Math.abs(c.x - this.selectedCenter.x);
                    let y = Math.abs(c.y - this.selectedCenter.y);
                    let q = this.entity('rect');
                    //q.coordinates = Cesium.Rectangle.fromDegrees( this.geodesics.west, this.geodesics.south, this.geodesics.east, this.geodesics.north ),
                    console.log('dragging', c, x, y, q.coordinates);
                }
            }
        }
    }
    pickObjects() {
        if (this.mouseCoords) {
            let test = this.mapService.viewer.scene.drillPick(this.mouseCoords, 3, 10, 10);
            // console.log ( '!!! @@@', test);
            return test;
        }
        return null;
    }
    rotate(angle) {
        let rect = this.entity('rect');
        rect.rectangle.rotation = Cesium.Math.toRadians(angle);
        // console.log ( '@@@@@@@@@@@@@@@@@@@@@@@@@', rect.rectangle.coordinates );
    }
    changeSizeX(size) {
        // this.entity ('rect' ).rectangle.rotation = Cesium.Math.toRadians(angle);
    }
    changeSizeY(size) {
        // this.entity ('rect' ).rectangle.rotation = Cesium.Math.toRadians(angle);
    }
    updateRectangle() {
        let A = this.coordHelper.getMiddlePoint({ long: this.geodesics.east, lat: this.geodesics.north }, { long: this.geodesics.east, lat: this.geodesics.south });
        let B = this.coordHelper.getMiddlePoint({ long: this.geodesics.west, lat: this.geodesics.south }, { long: this.geodesics.east, lat: this.geodesics.south });
        this.coordHelper.updateCartesian(A);
        this.coordHelper.updateCartesian(B);
    }
    findMiddle(coords = null) {
        if (!coords) {
            return;
        }
        this.coords = coords;
        if (!this.selectedCenter) {
            this.selectedCenter = this.coordHelper.findGeocenter(coords);
            this.coordHelper.updateCartesian(this.selectedCenter);
            this.geodesics = this.coordHelper.getRectangle(coords);
            // this.sizeX = this.geodesics.west;
            // this.sizeY = this.geodesics.north;
            if (this.debug) {
                console.log('%c selection-area.plugin %c findMiddle() RESULT', this.debugPrimary, this.debugSecondary, this.selectedCenter);
            }
        }
        this.wipe();
        let sizer = new coord_helper_service_1.CoordGeodetic({ long: this.geodesics.east, lat: this.geodesics.north });
        this.coordHelper.updateCartesian(sizer);
        /*
        this.coordHelper.getMiddlePoint (
            { long:this.geodesics.east, lat:this.geodesics.north },
            { long: this.geodesics.east, lat: this.geodesics.south }
        );
        let B = this.coordHelper.getMiddlePoint (
            { long:this.geodesics.west, lat:this.geodesics.south },
            { long:this.geodesics.east, lat:this.geodesics.south }
        );
        this.coordHelper.updateCartesian ( A ) ;
        */
        if (this.debug) {
            console.log('%c selection-area.plugin %c findMiddle() BOX', this.debugPrimary, this.debugSecondary, this.geodesics, sizer);
        }
        if (this.selectedCenter) {
            this.entity('primary', this.mapService.viewer.entities.add(this.getEntityType('draggable-move', {
                name: 'selection-area : middle point',
                position: this.selectedCenter,
                show: this.show
            })));
            this.entity('sizer', this.mapService.viewer.entities.add(this.getEntityType('draggable-size', {
                name: 'selection-area : sizer',
                position: sizer,
                show: this.show
            })));
            this.entity('rect', this.mapService.viewer.entities.add({
                name: 'selection-area : rectangle',
                show: true,
                rectangle: {
                    coordinates: Cesium.Rectangle.fromDegrees(this.geodesics.west, this.geodesics.south, this.geodesics.east, this.geodesics.north),
                    outline: true,
                    outlineColor: Cesium.Color.WHITE,
                    outlineWidth: 4,
                    fill: true,
                    rotation: Cesium.Math.toRadians(this.rotation),
                    material: Cesium.Color.YELLOW.withAlpha(0.4),
                },
            }));
            this.showHide();
        }
    }
}
SelectionAreaHandler.meta = {
    label: 'PLUGINS.SELECTION_AREA_HANDLER.LABEL',
    name: 'selection-area-handler',
    translator: 'PLUGINS.SELECTION_AREA_HANDLER',
    tooltip: 'PLUGINS.SELECTION_AREA_HANDLER.TOOLTIP',
    category: plugins_1.FdmPlugin.category.internal,
    types: [plugins_1.FdmPlugin.types.coordController]
};
exports.SelectionAreaHandler = SelectionAreaHandler;
